// ReSharper disable once UnusedLocalImport
import React, { Component, ChangeEvent, FormEvent } from "react";
import {
    Button, Container, Row, ListGroup, ListGroupItem, Badge, Card, CardBody, CardTitle, CardSubtitle, CardText,
    ListGroupItemHeading, ListGroupItemText, Col, Form, FormGroup, Label, Input, FormText, Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import {
    Options, Option, OscillatorType, OperatingVoltage, Packaging, RfOutputType,
    rfOutputTypes, oscillatorTypes, operatingVoltages, packagings
} from "../models/options";
import "./partResult.css"

type State = {
    modal: boolean,
    qtyValue: number
}

type Props = {
    rfOutputType: RfOutputType,
    oscillatorType: OscillatorType,
    operatingVoltage: OperatingVoltage,
    frequency: Number,
    packaging: Packaging;
}

export default class PartResult extends React.Component<Props, State> {
    constructor(props: any) {
        super(props);
        this.state = {
          modal: false,
          qtyValue: 0
        };
    
        this.toggle = this.toggle.bind(this);
      }
    
      toggle() {
        this.setState(prevState => ({
          modal: !prevState.modal
        }));
      }

      updateQtyValue(evt:any) {
        this.setState({
          qtyValue: evt.target.value
        });
      }
    
    render() {
        const rfOutputValue = rfOutputTypes[this.props.rfOutputType].value || "?";
        const typeValue = oscillatorTypes[this.props.oscillatorType].value || "?";
        const opVoltageValue = operatingVoltages[this.props.operatingVoltage].value || "?";
        const frequencyValue = this.props.frequency;
        const packagingValue = packagings[this.props.packaging].value || "?";
        const partNumber = `PRT-${rfOutputValue}-${typeValue}-${opVoltageValue}-${frequencyValue}MHz-${packagingValue}`;

        const hidder = this.props.oscillatorType === OscillatorType.NA ||
                              this.props.operatingVoltage === OperatingVoltage.NA ||
                              this.props.packaging === Packaging.NA ||
                              this.props.rfOutputType === RfOutputType.NA
                              ? "pb-item no-touch"
                              : "pb-item";

        return (

            <ul className="pb-list">
                <li className="pb-item">
                    <div className="pb-item_label">Prefix</div>
                    <div className="pb-item_box no-hover" id="prefix">
                        <span className="pb-item_text">P</span>
                        <span className="pb-item_text">R</span>
                        <span className="pb-item_text">T</span>
                    </div>
                </li>
                <li className="pb-item--separator" id="sep1">–</li>
                <li className="pb-item" id="rfoutput">
                    <div className="pb-item_label">Output</div>
                    <div className="pb-item_box">{rfOutputValue}</div>
                </li>
                <li className="pb-item--separator" id="sep2">–</li>
                <li className="pb-item" id="oscoutput">
                    <div className="pb-item_label">Type</div>
                    <div className="pb-item_box">{typeValue}</div>
                </li>
                <li className="pb-item--separator" id="sep3">–</li>
                <li className="pb-item" id="opoutput">
                    <div className="pb-item_label">Voltage</div>
                    <div className="pb-item_box">{opVoltageValue}</div>
                </li>
                <li className="pb-item--separator" id="sep4">–</li>
                <li className="pb-item" id="mhzoutput">
                    <div className="pb-item_label">Frequency</div>
                    <div className="pb-item_box">{frequencyValue}MHz</div>
                </li>
                <li className="pb-item--separator" id="sep5">–</li>
                <li className="pb-item" id="packageoutput">
                    <div className="pb-item_label">Package</div>
                    <div className="pb-item_box">{packagingValue}</div>
                </li>
                <li className="pb-item--separator" id="sep6">&times;</li>
                <li className="pb-item" id="qty">
                    <div className="pb-item_label">Quantity</div>
                    <input className="pg-quantity pb-item_box" type="text" value={this.state.qtyValue} onChange={evt => this.updateQtyValue(evt)}/>
                </li>
                <li className="pb-item--separator" id="sep7"></li>
                <li className={hidder} id="addtocart">
                    <Button onClick={this.toggle} id="addtoCartButton">Add to cart</Button>
                </li>
              <Modal id="modal" isOpen={this.state.modal} toggle={this.toggle}>
              <ModalHeader toggle={this.toggle}>Added to Cart</ModalHeader>
              <ModalBody>
                    <h3>{partNumber} &times; {this.state.qtyValue}</h3>
                    <img  className="pb-modal_img" src="aig_xo.png" alt={partNumber}/>
                    <p className="pb-modal_body" >3299 In Stock - $0.32</p>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={this.toggle}>Go to Cart</Button>
              </ModalFooter>
            </Modal>
            </ul>

        );
    }
}